import { Observable } from 'rxjs';
import api from 'utils/api';

export interface IRegions {
	key: string;
	region: string;
	city: string;
}

export interface ICity {
	key: string;
	name_ar: string;
	name_en: string;
}

export interface ICities {
	key: string;
	name_ar?: string;
	name_en?: string;
	cities: ICity[];
}

export class AddressesService {
	public static getCities(): Observable<any> {
		return api.wcm
			.getCities()
			.disableCache()
			.call();
	}

	public static getRegions(): Observable<any> {
		return api.wcm
			.getRegions()
			.disableCache()
			.call();
	}
}

export default AddressesService;
